module.exports = __webpack_public_path__ + "img/8448e0b50b4f679723ac5ab54ba81ece.c836f868.png";